import { Anchor, Checkbox, Text } from "@mantine/core";
import { HiCheck } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { useTermsByLanguage } from "../../utils/GetTerms";

interface IProps {
  acceptTerm: boolean | undefined;
  handleAcceptTerm: () => void;
}

export default function AcceptClientTerms({
  acceptTerm = false,
  handleAcceptTerm,
}: IProps) {
  const { t } = useTranslation();
  const termsLink = useTermsByLanguage();

  return (
    <Checkbox
      color="primary.1"
      size="md"
      icon={HiCheck}
      onChange={handleAcceptTerm}
      checked={acceptTerm}
      label={
        <Text>
          {t("global.accept_terms.text")}{" "}
          <Anchor href={termsLink} target="_blank">
            {t("global.accept_terms.terms_of_use")}
          </Anchor>
        </Text>
      }
    />
  );
}
